module.exports = __webpack_public_path__ + "static/media/quieromibarriomini.538b5754.jpg";